export default __webpack_public_path__ + "static/media/oliver-peoples-3.70c18cb7.png";